module.exports = __webpack_public_path__ + "static/img/wallpaper.a2df82ce.jpg";